import FbButton from 'components/FbUI/FbButton'

interface SenderEmailsEmptyStateProps {
  onSync: () => void
  onAdd: () => void
  isSyncing: boolean
}

export function SenderEmailsEmptyState({
  onSync,
  onAdd,
  isSyncing,
}: SenderEmailsEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center h-full py-12">
      <div className="text-center max-w-md">
        <h3 className="text-lg font-semibold text-fg mb-2">
          No sender emails attached
        </h3>
        <p className="text-sm text-fg-secondary mb-6">
          Attach sender email accounts to this campaign to start sending emails.
          First sync your workspace sender emails, then add them to this
          campaign.
        </p>
        <div className="flex gap-3 justify-center">
          <FbButton onClick={onSync} disabled={isSyncing} variant="secondary">
            {isSyncing ? 'Syncing...' : 'Sync Workspace'}
          </FbButton>
          <FbButton onClick={onAdd} variant="primary">
            Add Sender Emails
          </FbButton>
        </div>
      </div>
    </div>
  )
}
